/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 *
 * @export
 * @interface UserRequest
 */
export interface UserRequest {
    /**
     *
     * @type {string}
     * @memberof UserRequest
     */
    requestId: string;
    /**
     *
     * @type {string}
     * @memberof UserRequest
     */
    timestamp: string;
    /**
     *
     * @type {string}
     * @memberof UserRequest
     */
    issueId: string;
    /**
     *
     * @type {string}
     * @memberof UserRequest
     */
    status: string;
    /**
     *
     * @type {string}
     * @memberof UserRequest
     */
    summary?: string;
    /**
     *
     * @type {string}
     * @memberof UserRequest
     */
    issueType?: string;
    /**
     *
     * @type {string}
     * @memberof UserRequest
     */
    description?: string;
    /**
     *
     * @type {string}
     * @memberof UserRequest
     */
    requestType?: string;
}

export function UserRequestFromJSON(json: any): UserRequest {
    return UserRequestFromJSONTyped(json, false);
}

export function UserRequestFromJSONTyped(json: any, _: boolean): UserRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'requestId': json['request_id'],
        'timestamp': json['timestamp'],
        'issueId': json['issue_id'],
        'status': json['status'],
        'summary': !exists(json, 'summary') ? undefined : json['summary'],
        'issueType': !exists(json, 'issue_type') ? undefined : json['issue_type'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'requestType': !exists(json, 'request_type') ? undefined : json['request_type'],
    };
}

export function UserRequestToJSON(value?: UserRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'request_id': value.requestId,
        'timestamp': value.timestamp,
        'issue_id': value.issueId,
        'status': value.status,
        'summary': value.summary,
        'issue_type': value.issueType,
        'description': value.description,
        'request_type': value.requestType,
    };
}
